// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__LZBl9","scale":"Text_scale__6N_4T"};